import script from "./docSore.vue?vue&type=script&setup=true&lang=js"
export * from "./docSore.vue?vue&type=script&setup=true&lang=js"

import "./docSore.vue?vue&type=style&index=0&id=3b716de3&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b716de3"]])

export default __exports__